import { cloneElement, ComponentProps, ReactElement } from 'react';

import { useLicenseStatus } from '@sbv-clients/data-access-api';
import { Button, IconButtonWithTooltip, Tooltip } from '@sbv-clients/ui-shared';
import { Messages } from '@sbv-clients/util-misc';

export const LicenseReadOnlyGuard = ({
  children,
  fallbackTitle = '',
}: {
  children: ReactElement<ComponentProps<typeof Button>>;
  fallbackTitle?: string;
}) => {
  const { isReadOnly, message } = useLicenseStatus();
  return (
    <Tooltip title={isReadOnly ? message ?? '' : fallbackTitle}>
      <span>
        {cloneElement(children, {
          disabled: !!isReadOnly || children.props.disabled,
        })}
      </span>
    </Tooltip>
  );
};

export const LicenseReadOnlyIconButton = ({
  children,
}: {
  children: ReactElement<ComponentProps<typeof IconButtonWithTooltip>>;
}) => {
  const { isReadOnly, message } = useLicenseStatus();
  return cloneElement(children, {
    title: isReadOnly
      ? message ?? Messages.MissingPermissions
      : children.props.title,
    disabled: !!isReadOnly || children.props.disabled,
  });
};
